import axios from "../axiosConfigs/axiosInstance";
import {
  BASE_API_URL,
  promiseError,
  promiseNull,
} from "../constants/allConstants";
import { firebase } from "../firebase/config";
import {
  convertTimestampToString5,
  processAllVendorContacts,
  processEquipmentRecords,
  processReturnedEquipmentRecords,
  uploadFileAndReturnDownloadableUrl,
} from "./itemsCRUD";
import { finishLoading, startLoading } from "./progress";
import {
  CREATE_EQUIPMET_ORDER_DONE,
  CREATE_EQUIPMET_RETURN_TO_SHOP_DONE,
  DELETE_EQUIPMENT_ORDER_DONE,
  FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
  RETURN_EQUIPMENT_ORDERS_TO_SHOP,
  RE_ASSIGN_ITEM_TO_JOB_DONE,
  SET_EQUIPMEMNT_JOB,
  SET_SELECTED_JOB_EQUIPMENTS,
  UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
  UPDATE_CURRENT_JOB_EQUIPMENT,
  UPDATE_EQUIPMENT_RECORD_CONTACTS,
  UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE,
  UPDATE_EQUIPMET_ORDER_DONE,
  UPDATE_RETURNED_EQUIPMENTS,
  UPDATE_RETURNS,
  UPDATE_EQUIPMENTS_FILTERED,
} from "./types";

// all actions start
const updateEqupmentForCurrentJob = (equipments) => {
  return {
    type: UPDATE_CURRENT_JOB_EQUIPMENT,
    currentJobEquipments: [...equipments],
  };
};
const updateEquipmentsFiltered = (equipments) => {
  return {
    type: UPDATE_EQUIPMENTS_FILTERED,
    filteredEquipments: [...equipments],
  };
};
const updateReturnedEquipments = (returnedEquipments) => {
  return {
    type: UPDATE_RETURNED_EQUIPMENTS,
    returnedEquipments: [...returnedEquipments],
  };
};
const updateReturns = (returns) => {
  return {
    type: UPDATE_RETURNS,
    returns: [...returns],
  };
};
const updateEquipmentsRecordContacts = () => {
  return {
    type: UPDATE_EQUIPMENT_RECORD_CONTACTS,
  };
};
export const setEquipmentJob = (job) => {
  return {
    type: SET_EQUIPMEMNT_JOB,
    equipmentJob: job,
  };
};
export const setSelectedJobEquipments = (equipments) => {
  return {
    type: SET_SELECTED_JOB_EQUIPMENTS,
    selectedJobEquipments: [...equipments],
  };
};
export const createEquipmentOrderDone = () => {
  return {
    type: CREATE_EQUIPMET_ORDER_DONE,
  };
};
export const updateEquipmentOrderDone = () => {
  return {
    type: UPDATE_EQUIPMET_ORDER_DONE,
  };
};
export const createEquipmentRecordReturnToShopDone = () => {
  return {
    type: CREATE_EQUIPMET_RETURN_TO_SHOP_DONE,
  };
};
export const reAssignItemToJobDone = () => {
  return {
    type: RE_ASSIGN_ITEM_TO_JOB_DONE,
  };
};
export const updateEquipmentRecordReturnToShopDone = () => {
  return {
    type: UPDATE_EQUIPMENT_RECORD_RETURN_TO_SHOP_DONE,
  };
};

export const deleteEquipmentOrderDone = () => {
  return {
    type: DELETE_EQUIPMENT_ORDER_DONE,
  };
};

export const returnEquipmentOrdersToShopDone = () => {
  return {
    type: RETURN_EQUIPMENT_ORDERS_TO_SHOP,
  };
};

export const fetchAllJobsEquipmentHidableColumnsDone = (hidableColumns) => {
  return {
    type: FETCH_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
    savedHiddenColumns: [...hidableColumns],
  };
};

export const updateAllJobsEquipmentHidableColumnsDone = () => {
  return {
    type: UPDATE_ALL_JOBS_EQUIPMENT_HIDABLE_COLUMNS_DONE,
  };
};

export const fetchEquipmentOrdersForJob = (jobId) => async (dispatch) => {
  if (jobId) {
    dispatch(startLoading("fetchEquipmentOrdersForJob"));
    let token = await firebase.auth().currentUser.getIdToken();
    if (!token) {
      dispatch(finishLoading("fetchEquipmentOrdersForJob"));
      return;
    }
    const response = await axios
      .get(`${BASE_API_URL}/equipmentsAPI?jobId=${jobId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .catch((error) => {
        return error;
      });
    if (response && response.status === 200) {
      dispatch(setSelectedJobEquipments([...response.data.data]));
      if (response.data.data.length > 0) {
        dispatch(
          setEquipmentJob({
            ...response.data.data[0].job,
          })
        );
      }
    } else if (response) {
      console.log(response);
    }

    dispatch(finishLoading("fetchEquipmentOrdersForJob"));
  }
};

export const fetchAllEquipmentsOrdersOfCompany = () => async (dispatch) => {
  dispatch(startLoading("fetchAllEquipmentsOrdersOfCompany"));
  let token = await firebase.auth().currentUser.getIdToken();
  if (!token) {
    dispatch(finishLoading("fetchAllEquipmentsOrdersOfCompany"));
    return;
  }
  const response = await axios
    .get(`${BASE_API_URL}/equipmentsAPI`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    })
    .catch((error) => {
      return error;
    });
  if (response && response.status === 200) {
    dispatch(updateEqupmentForCurrentJob([...response.data.data]));
  } else if (response) {
    console.log(response);
  }

  dispatch(finishLoading("fetchAllEquipmentsOrdersOfCompany"));
};

export const filterEquipmentsBy = 
  (jobId = null, startDate = null, endDate = null)=> async (dispatch) => {
    if (jobId) {
      dispatch(startLoading("filterEquipments"));
      let token = await firebase.auth().currentUser.getIdToken();
      if (!token) {
        dispatch(finishLoading("filterEquipments"));
        return;
      }
      const BASE_API_URLs = "http://localhost:5001/sitetrace-dev/us-central1"
      const response = await axios
        .get(`${BASE_API_URLs}/equipmentsAPI?jobId=${jobId}&startDate=${startDate}&endDate=${endDate}`, {
          headers: {
            Authorization: "Bearer " + token,
          },
        })
        .catch((error) => {
          return error;
        });
      if (response && response.status === 200) {
        dispatch(updateEquipmentsFiltered([...response.data.data]));
      } else if (response) {
        console.log(response);
      }
  
     
    dispatch(finishLoading("filterEquipments"));
    }
  }


export const createEquipmentsOrdersOfCompany =
  (records, equipment, filesToUpload, user) => async (dispatch) => {
    dispatch(startLoading("createEquipmentsOrdersOfCompany"));
    const storageRef = firebase.storage().ref();
    const path = "companies/" + user.company + "/poAttachments/";

    // upload new files
    const filesUploadPromises = [];
    filesToUpload.forEach((file) => {
      const uploadPromise = uploadFileAndReturnDownloadableUrl(
        path,
        storageRef,
        file
      );
      filesUploadPromises.push(uploadPromise);
    });
    const uploadsResults = await Promise.all(filesUploadPromises);

    let token = await firebase.auth().currentUser.getIdToken();
    if (!token) {
      dispatch(finishLoading("createEquipmentsOrdersOfCompany"));
      return;
    }
    const { category, job, poAttachments, poNumber, vendorId } = equipment;
    const body = {
      records: [...records],
      equipment: { category, jobId: job, poAttachments, poNumber, vendorId },
      attachments: uploadsResults,
    };
    const response = await axios
      .post(`${BASE_API_URL}/equipmentsAPI`, body, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .catch((error) => {
        return error;
      });

    if (response && response.status === 200) {
    } else if (response) {
      console.log(response);
    }
    dispatch(createEquipmentOrderDone());
    dispatch(finishLoading("createEquipmentsOrdersOfCompany"));
  };

export const updateEquipmentsOrdersOfCompany =
  (
    records,
    recordsToDelete,
    equipment,
    filesToUpload,
    attachmentsToDelete,
    user
  ) =>
  async (dispatch) => {
    dispatch(startLoading("updateEquipmentsOrdersOfCompany"));
    const storageRef = firebase.storage().ref();
    const path = "companies/" + user.company + "/poAttachments/";

    // upload new files
    const filesUploadPromises = [];
    filesToUpload.forEach((file) => {
      const uploadPromise = uploadFileAndReturnDownloadableUrl(
        path,
        storageRef,
        file
      );
      filesUploadPromises.push(uploadPromise);
    });

    const uploadsResults = await Promise.all(filesUploadPromises);

    let token = await firebase.auth().currentUser.getIdToken();
    if (!token) {
      dispatch(finishLoading("updateEquipmentsOrdersOfCompany"));
      return;
    }
    const { id, category, job, poAttachments, poNumber, vendorId } = equipment;
    const body = {
      records: [...records],
      equipment: {
        id,
        category,
        jobId: job,
        poAttachments,
        poNumber,
        vendorId,
      },
      attachments: uploadsResults,
      recordsToDelete: [...recordsToDelete.map((record) => record.id)],
      attachmentsToDelete: [...attachmentsToDelete],
    };
    const response = await axios
      .put(`${BASE_API_URL}/equipmentsAPI`, body, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .catch((error) => {
        return error;
      });

    if (response && response.status === 200) {
    } else if (response) {
      console.log(response);
    }
    dispatch(updateEquipmentOrderDone());
    dispatch(finishLoading("updateEquipmentsOrdersOfCompany"));
  };

export const fetchEquipmentsReturned = (user) => (dispatch) => {
  dispatch(startLoading("fetchEquipmentsReturned"));
  return firebase
    .firestore()
    .collection("materialRecords")
    .where("company", "==", user.company)
    .where("isReturn", "==", true)
    .where("type", "==", "EQUIPMENT")
    .get()
    .then((equipsRef) => {
      const equipments = [];
      equipsRef.forEach((equip) => {
        equipments.push(equip.data());
      });
      return processReturnedEquipmentRecords(equipments);
    })
    .then((equipments) => {
      dispatch(updateReturnedEquipments(equipments));
      dispatch(finishLoading("fetchEquipmentsReturned"));
    })
    .catch(() => {
      dispatch(finishLoading("fetchEquipmentsReturned"));
    });
};

export const addContactsToEquipmentsRecord =
  (recordId, contactList, projectOwner) => (dispatch) => {
    dispatch(startLoading("addContactsToEquipmentsRecord"));
    const owners = [...[projectOwner], ...contactList];
    return firebase
      .firestore()
      .collection("materialRecords")
      .doc(recordId)
      .update({
        materialOwners: owners,
      })
      .then(() => {
        dispatch(updateEquipmentsRecordContacts());
        dispatch(finishLoading("addContactsToEquipmentsRecord"));
      });
  };

export const createEquipmentRecordReturnToShop =
  (record, filesToUpload, user) => (dispatch) => {
    dispatch(startLoading("createEquipmentRecordReturnToShop"));

    const storageRef = firebase.storage().ref();
    const path = "companies/" + user.company + "/packingSlipAttachments/";
    // upload new files
    const filesUploadPromises = [];
    filesToUpload.forEach((file) => {
      const uploadPromise = uploadFileAndReturnDownloadableUrl(
        path,
        storageRef,
        file
      );
      filesUploadPromises.push(uploadPromise);
    });
    return Promise.all(filesUploadPromises).then(async (uploadsResults) => {
      let newEquipmentOrder = {};
      if (uploadsResults.length > 0) {
        newEquipmentOrder = {
          ...record,
          packingSlipAttachments: uploadsResults,
        };
      } else {
        newEquipmentOrder = { ...record };
      }
      new Promise(async (resolve) => {
        const returnsRef = await firebase
          .firestore()
          .collection("returns")
          .where("company", "==", user.company)
          .where("item", "==", record.item + "")
          .where("size", "==", record.size + "")
          .where("vendorId", "==", record.vendorId)
          .where("category", "==", record.category)
          .get()
          .catch();
        // create new return if item with details does not exist
        if (returnsRef && returnsRef.docs.length > 0) {
          resolve({ ...returnsRef.docs[0].data() });
        } else {
          const newReturn = {
            company: user.company,
            category: record.category ? record.category : "",
            item: record.item ? record.item : "",
            size: record.size ? record.size : 0,
            quantity: record.quantity ? parseInt(record.quantity) : 0,
            totalDollarValue: record.dollarValue
              ? parseInt(record.dollarValue)
              : 0,
            vendorId: record.vendorId ? record.vendorId : "",
            description: record.description ? record.description : "",
            packingSlipAttachments: uploadsResults,
          };
          const newReturnRef = await firebase
            .firestore()
            .collection("returns")
            .add(newReturn);
          if (newReturnRef) {
            await firebase
              .firestore()
              .collection("returns")
              .doc(newReturnRef.id)
              .update({ id: newReturnRef.id });
            resolve({ ...newReturn, id: newReturnRef.id });
          }
        }
      }).then((recordedReturn) => {
        const newMaterialRecord = {
          ...newEquipmentOrder,
          returnId: recordedReturn.id,
          size: record.size ? record.size : 0,
        };
        // create new record with the return id
        firebase
          .firestore()
          .collection("materialRecords")
          .add({ ...newMaterialRecord })
          .then((equipRef) => {
            return firebase
              .firestore()
              .collection("materialRecords")
              .doc(equipRef.id)
              .update({ id: equipRef.id })
              .then(async () => {
                try {
                  const snapshot = await firebase
                    .firestore()
                    .collection("materialRecords")
                    .where("company", "==", user.company)
                    .where("returnId", "==", recordedReturn.id)
                    .get();
                  // calculater the total dollar value
                  let totalDollarValue = 0;
                  snapshot.docs.forEach((record) => {
                    const details = record.data();
                    if (details.dollarValue) {
                      totalDollarValue =
                        totalDollarValue + parseInt(details.dollarValue);
                    }
                  });
                  // update returned item total Dollar Value
                  await firebase
                    .firestore()
                    .collection("returns")
                    .doc(recordedReturn.id)
                    .update({
                      totalDollarValue: totalDollarValue,
                    });
                } catch (error) {}
                dispatch(createEquipmentRecordReturnToShopDone());
                dispatch(finishLoading("createEquipmentRecordReturnToShop"));
              });
          })
          .catch(() => {});
      });
    });
  };

export const reAssignItemToJob =
  (equipment, job, contact, user) => (dispatch) => {
    dispatch(startLoading("ReAssignItemToJob"));

    firebase
      .firestore()
      .collection("equipmentOrders")
      .where("company", "==", user.company)
      .where("poNumber", "==", "Reassigned from shop")
      .where("vendorId", "==", equipment.vendorId ? equipment.vendorId : "")
      .where("job", "==", job.id)
      .get()
      .then((res) => {
        return new Promise(async (resolve) => {
          // create new order if it does not exist
          if (!res.empty) {
            resolve(res.docs[0].data());
          } else {
            const equip = {
              poNumber: "Reassigned from shop",
              vendorId: equipment.vendorId ? equipment.vendorId : "",
              category: "Other",
              company: user.company,
              job: job.id,
              poAttachments: [],
              createdAt: new Date(),
            };
            firebase
              .firestore()
              .collection("equipmentOrders")
              .add({ ...equip })
              .then((equipRef) => {
                firebase
                  .firestore()
                  .collection("equipmentOrders")
                  .doc(equipRef.id)
                  .update({ id: equipRef.id })
                  .then(() => {
                    resolve({ ...equip, id: equipRef.id });
                  });
              });
          }
        });
      })
      .then(async (equipmentOrder) => {
        let materialOwnwers = [];
        if (job.materialOwners) {
          const owners = job.materialOwners.map((owner) => owner.id);
          materialOwnwers = [...materialOwnwers, ...owners];
        }
        // update details of reassigned record
        materialOwnwers.push(contact.id);
        firebase
          .firestore()
          .collection("materialRecords")
          .doc(equipment.id)
          .update({
            job: job.id,
            poNumber: equipmentOrder.poNumber,
            po: equipmentOrder.id,
            lastEditedAt: new Date(),
            lastEditedBy: user.id,
            materialOwners: [...new Set(materialOwnwers)],
            checkedOutBy: user.id,
            checkedOutAt: new Date(),
            status: "LEAVING_SHOP",
          })
          .then(() => {
            dispatch(reAssignItemToJobDone());
            dispatch(finishLoading("ReAssignItemToJob"));
          });
      });
  };

export const updateEquipmentRecordReturnToShop =
  (recordEdited, filesToUpload, filesToDelete, user) => (dispatch) => {
    dispatch(startLoading("updateEquipmentRecordReturnToShop"));
    const storageRef = firebase.storage().ref();
    const path = "companies/" + user.company + "/packingSlipAttachments/";
    const filesUploadPromises = [];
    // upload new files
    filesToUpload.forEach((file) => {
      const uploadPromise = uploadFileAndReturnDownloadableUrl(
        path,
        storageRef,
        file
      );
      filesUploadPromises.push(uploadPromise);
    });
    return Promise.all(filesUploadPromises).then((uploadsResults) => {
      let newEquipmentOrder = {};
      if (uploadsResults.length > 0) {
        newEquipmentOrder = {
          ...recordEdited,
          packingSlipAttachments: uploadsResults,
        };
      } else {
        newEquipmentOrder = { ...recordEdited };
      }
      firebase
        .firestore()
        .collection("materialRecords")
        .doc(recordEdited.id)
        .update({ ...newEquipmentOrder })
        .then(() => {
          const rattachmentsToDeletePromises = [];
          filesToDelete.forEach((attachment) => {
            const rec = firebase.storage().refFromURL(attachment.url).delete();
            rattachmentsToDeletePromises.push(rec);
          });
          Promise.all(rattachmentsToDeletePromises).then(() => {
            dispatch(finishLoading("updateEquipmentRecordReturnToShop"));
            dispatch(updateEquipmentRecordReturnToShopDone());
          });
        })
        .catch(() => {});
    });
  };

export const deleteEquipmentsOrder = (equipmentOrder, user) => (dispatch) => {
  dispatch(startLoading("deleteEquipmentsOrder"));

  return firebase
    .firestore()
    .collection("equipmentOrders")
    .doc(equipmentOrder.id)
    .delete()
    .then(() => {
      firebase
        .firestore()
        .collection("materialRecords")
        .where("company", "==", user.company)
        .where("po", "==", equipmentOrder.id)
        .get()
        .then((equipmentsRef) => {
          const recordsToDeletePromises = [];
          equipmentsRef.forEach((equip) => {
            const rec = firebase
              .firestore()
              .collection("materialRecords")
              .doc(equip.id)
              .delete();
            recordsToDeletePromises.push(rec);
          });
          Promise.all(recordsToDeletePromises).then(() => {
            dispatch(finishLoading("deleteEquipmentsOrder"));
            dispatch(deleteEquipmentOrderDone());
          });
        });
    })
    .catch(() => {});
};

// creates return to shop
export const returnEquipmentsRecordsToShop =
  (equpmentOrder, equipmentRecordsToReturn, user) => (dispatch) => {
    dispatch(startLoading("returnEquipmentsOrderToShop"));
    new Promise((resolve) => {
      const equipmentsToReturnPromises = [];
      equipmentRecordsToReturn.forEach((quipment) => {
        const equip = {
          poNumber: "",
          vendor: "",
          materialOwners: [],
          job: "",
          po: "",
          status: "",
          isReturn: true,
          poNumberFrom: quipment.poNumber ? quipment.poNumber : "",
          jobFrom: quipment.job
            ? quipment.job.id
              ? quipment.job.id
              : quipment.job
            : "",
          lastEditedAt: new Date(),
          lastEditedBy: user.id,
          checkedOutAt: null,
          checkedOutBy: "",
          createdAt: new Date(),
          createdBy: user.id,
        };

        const ref = firebase
          .firestore()
          .collection("materialRecords")
          .doc(quipment.id)
          .update({ ...equip });
        equipmentsToReturnPromises.push(ref);
      });
      Promise.all(equipmentsToReturnPromises).then(() => {
        if (equpmentOrder.id) {
          // clean up all records that belonged to the previous order
          firebase
            .firestore()
            .collection("materialRecords")
            .where("company", "==", user.company)
            .where("po", "==", equpmentOrder.id)
            .get()
            .then(async (allRecordsRef) => {
              if (allRecordsRef.empty) {
                try {
                  await firebase
                    .firestore()
                    .collection("equipmentOrders")
                    .doc(equpmentOrder.id)
                    .delete();
                } catch (error) {}

                resolve();
              } else {
                resolve();
              }
            });
        } else {
          resolve();
        }
      });
    }).then(() => {
      dispatch(returnEquipmentOrdersToShopDone());
      dispatch(finishLoading("returnEquipmentsOrderToShop"));
    });
  };

export const fetchReturnOfCompany = (user) => (dispatch) => {
  dispatch(startLoading("fetchReturnOfCompany"));
  firebase
    .firestore()
    .collection("returns")
    .where("company", "==", user.company)
    .get()
    .then(async (returnsSnapshots) => {
      let allReturns = [];
      for (const returnsSnapshot of returnsSnapshots.docs) {
        let returnsDetails = returnsSnapshot.data();
        let equipmentsData = [];
        if (returnsDetails.id) {
          try {
            const snapshot = await firebase
              .firestore()
              .collection("materialRecords")
              .where("company", "==", user.company)
              .where("returnId", "==", returnsDetails.id)
              .get();
            equipmentsData = snapshot.docs.map((record) => record.data());
          } catch (error) {}
          try {
            const vendorData = await firebase
              .firestore()
              .collection("vendors")
              .doc(returnsDetails.vendorId)
              .get()
              .catch();
            if (vendorData) {
              returnsDetails = { ...returnsDetails, vendorDetails: vendorData };
            } else {
              returnsDetails = { ...returnsDetails, vendorDetails: {} };
            }
          } catch (error) {}
        }
        try {
          const equipmentsDetails = await processReturnedEquipmentRecords(
            equipmentsData
          ).catch();
          allReturns.push({
            ...returnsDetails,
            equipmentRecords: [...equipmentsDetails],
          });
        } catch (error) {}
      }
      dispatch(updateReturns(allReturns));
      dispatch(finishLoading("fetchReturnOfCompany"));
    });
};

export const updateAllJobsEquipmentHidableColumns =
  (hidableColumns, user) => async (dispatch) => {
    dispatch(startLoading("updateAllJobsEquipmentHidableColumns"));
    const allJobsEquipmentHiddenColumns = Object.keys(hidableColumns).reduce(
      (previous, currentKey) => {
        const value = hidableColumns[currentKey];
        if (value && !value.isVisible) {
          if (currentKey === "po") {
            return [...previous, "category"];
          }
          if (currentKey === "vendorDetails") {
            return [...previous, "vendorId"];
          }
          return [...previous, currentKey];
        }
        return [...previous];
      },
      []
    );
    await firebase
      .firestore()
      .collection("users")
      .doc(user.id)
      .update({ allJobsEquipmentHiddenColumns });
    dispatch(finishLoading("updateAllJobsEquipmentHidableColumns"));
    dispatch(updateAllJobsEquipmentHidableColumnsDone());
  };
